var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "address",
      class: {
        "address-disabled": _vm.cityClosed,
        "address-selected": _vm.selected
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "address-content",
          on: {
            click: function($event) {
              !_vm.cityClosed && _vm.selectAddress(_vm.address.id)
            }
          }
        },
        [
          _c("span", { staticClass: "address-label" }, [
            _vm._v("\n      " + _vm._s(_vm._f("name")(_vm.address)) + "\n    ")
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "address-street" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm._f("streetAddress")(_vm.address)) +
                "\n    "
            )
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "address-city" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm._f("residencyLocation")(_vm.address)) +
                "\n    "
            )
          ]),
          _vm._v(" "),
          _vm.cityClosed
            ? _c("p", { staticClass: "alert" }, [
                _vm._v("\n      Não estamos operando mais nessa cidade!\n    ")
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      !_vm.cityClosed
        ? _c("img", {
            attrs: { src: "/static/icon-edit.svg" },
            on: {
              click: function($event) {
                _vm.editing = true
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.editing
        ? _c("EditAddress", {
            attrs: { address: _vm.address },
            on: {
              close: function($event) {
                _vm.editing = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c49caef8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c49caef8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PurchaseFlow/Components/Scheduler/Steps/Address/Address.vue
// module id = null
// module chunks = 